import { render, staticRenderFns } from "./lhc_ball.vue?vue&type=template&id=a4984684&scoped=true"
import script from "./lhc_ball.vue?vue&type=script&lang=js"
export * from "./lhc_ball.vue?vue&type=script&lang=js"
import style0 from "./lhc_ball.vue?vue&type=style&index=0&id=a4984684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4984684",
  null
  
)

export default component.exports